import keyboardJS from 'keyboardjs'

export default {
  data () {
    return {
      shiftPressed: false
    }
  },

  methods: {
    isMac () {
      return window.navigator.match('Mac')
    }
  },

  mounted () {
    let vm = this
    keyboardJS.setContext('train-template')

    keyboardJS.bind('shift', function (e) {
      vm.shiftPressed = true
    }, function (e) {
      vm.shiftPressed = false
    })

    keyboardJS.bind('escape', function (e) {
      if (vm.$route.name !== 'train') { return }
      if (!vm.showNewMapping) {
        e.preventDefault()
        vm.enableSelection()
      }
    })

    keyboardJS.bind('tab', function (e) {
      if (vm.$route.name !== 'train') { return }
      if (!vm.showNewMapping) {
        // vm.selectNextShape(e)
        // e.preventDefault()
      }
    })

    keyboardJS.bind('command > s', null, function (e) {
      if (vm.$route.name !== 'train') { return }
      e.preventDefault()
      vm.saveData()
    })

    keyboardJS.bind('command > +', null, function (e) {
      if (vm.$route.name !== 'train') { return }
      e.preventDefault()
      vm.zoomIn()
    })

    keyboardJS.bind('command > -', null, function (e) {
      if (vm.$route.name !== 'train') { return }
      e.preventDefault()
      vm.zoomOut()
    })

    keyboardJS.bind('command > d', null, function (e) {
      if (vm.$route.name !== 'train') { return }
      e.preventDefault()
      vm.removeShape()
    })

    keyboardJS.bind('command > x', null, function (e) {
      if (vm.$route.name !== 'train') { return }
      e.preventDefault()
      vm.cutShape()
    })

    keyboardJS.bind('command > c', null, function (e) {
      if (vm.$route.name !== 'train') { return }
      e.preventDefault()
      vm.copyShape()
    })

    keyboardJS.bind('command > v', null, function (e) {
      if (vm.$route.name !== 'train') { return }
      e.preventDefault()
      vm.pasteShape()
    })

    keyboardJS.bind('command > z', null, function (e) {
      if (vm.$route.name !== 'train') { return }
      e.preventDefault()
      vm.undo()
    })

    keyboardJS.bind('command + shift > z', null, function (e) {
      if (vm.$route.name !== 'train') { return }
      e.preventDefault()
      vm.redo()
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/keyBindings.js